import { render, staticRenderFns } from "./LettersEditor.vue?vue&type=template&id=7160044c&scoped=true&"
import script from "./LettersEditor.vue?vue&type=script&lang=js&"
export * from "./LettersEditor.vue?vue&type=script&lang=js&"
import style0 from "./LettersEditor.vue?vue&type=style&index=0&id=7160044c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160044c",
  null
  
)

export default component.exports